module.exports = __webpack_public_path__ + "static/media/Foot Injury - Hexagon.9488aa52.png";